import {
    FormControl,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    InputLabel,
    IconButton,
    OutlinedInput,
    Box,
    Avatar,
    Typography,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { useGetPeoples } from "../../api/settings";

const DropdownIcon = (props) => (
    <Icon
        icon="eva:arrow-ios-downward-fill"
        width="18"
        height="18"
        {...props}
    />
);

function DoctorFilter({ value = [], onChange, component }) {
    const { peoples = [] } = useGetPeoples({
        role: "b2b-doctor",
        isActiveOnly: false,
    });

    const selectedIds = Array.isArray(value) ? value : [];

    return (
        <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select
                multiple
                value={selectedIds}
                onChange={(e) => onChange(e.target.value)}
                IconComponent={DropdownIcon}
                input={<OutlinedInput />}
                displayEmpty
                renderValue={(selected) => (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            fontSize: "14px",
                            fontWeight: 500,
                        }}
                    >
                        <span>Doctors</span>
                        {selected.length > 0 && (
                            <Box
                                sx={{
                                    minWidth: 18,
                                    height: 18,
                                    borderRadius: "50%",
                                    backgroundColor: "#6C63FF",
                                    color: "#fff",
                                    fontSize: 12,
                                    fontWeight: 600,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                {selected.length}
                            </Box>
                        )}
                    </Box>
                )}
                sx={{
                    height: 38,
                    width: selectedIds.length > 0 ? 120 : 90,
                    borderRadius: "10px",
                    backgroundColor: component === "referred-cases" ? "var(--app-surface)" : "var(--app-surface)",
                    "& fieldset": { border: "none" },
                    "& .MuiSelect-select": {
                        display: "flex",
                        alignItems: "center",
                        padding: "8px 12px",
                    },
                }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            width: 230,
                            borderRadius: "10px",
                            mt: 1,
                            border: "1px solid var(--app-border)",
                            boxShadow: "var(--app-shadow)",
                        },
                    },
                    MenuListProps: {
                        sx: {
                            maxHeight: 320,
                            overflowY: "auto",
                        },
                    },
                    disableScrollLock: true,
                }}
            >
                {peoples.map((doc) => (
                    <MenuItem key={doc._id} value={doc._id}>
                        <Checkbox checked={selectedIds.includes(doc._id)} size="small"
                            sx={{
                                mr: 1,
                                color: "var(--app-border)",
                                  "&.Mui-checked": {
      color: "#5751E9", //  checked color
    },
                                "& .MuiSvgIcon-root": {
                                    borderRadius: "8px",
                                    fontSize: 20,
                                },
                            }} />
                        <ListItemText
                            primary={doc.fullName}
                            primaryTypographyProps={{
                                fontSize: "14px",
                                color: "var(--app-text)",
                                fontWeight: 500,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
export default DoctorFilter;
